import { useFormik } from "formik";
import React, { useMemo, useState, Fragment, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { Modal, Form, Nav, InputGroup } from "react-bootstrap";
import Cookies from "universal-cookie";

import { toast } from "react-toastify";
import "../../assets/scss/RolesPriviledgesModal.scss";
import * as yup from "yup";
import EyeOffOutline from "mdi-react/EyeOffOutlineIcon";
import EyeOutline from "mdi-react/EyeOutlineIcon";

import useDebounce, {
  useBackendUrl,
  useEffectOnce,
  useIsAdmin,
} from "../../utils/hooks";
import { useFetchUsers } from "../../hooks/useFetchUsers";
import { useAuth } from "../../hooks/useAuth";
import { useStoreActions, useStoreState } from "easy-peasy";
import { GearIcon } from "../Icons";
import { useMutation, useQuery } from "react-query";
import { initialGeneralSettings } from "../../utils/helpers";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import ExpensesSelector from "../utils/ExpensesSelector";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Popover } from "react-tiny-popover";
import eventBus from "../../utils/EventBus";
import roles from "../roles.json";
import { isEmpty } from "lodash";

export default function RolesPriviledgesModal({
  showEditUserPriviledgesModal,
  setShowEditUserPriviledgesModal,
  userId,
  userName,
}) {
  const showRolesPriviledgesModal = showEditUserPriviledgesModal;
  const setShowRolesPriviledgesModal = setShowEditUserPriviledgesModal;

  const savedDeptRoles = useStoreState((state) => state.savedDeptRoles);

  const [savedStaffRoles, setSavedStaffroles] = useState([]);

  const { backendUrl, user } = useAuth();
  const isAdmin = useIsAdmin();
  //const generalSettings = useStoreState((state) => state.generalSettings);
  const setGeneralSettings = useStoreActions(
    (actions) => actions.setGeneralSettings
  );
  const [showJournalPopover, setShowJournalPopover] = useState(false);
  const [priveledges, setPriveledges] = useState(
    savedStaffRoles ? savedStaffRoles : []
  );
  // const [userRoles, setUserRoles] = useState(roles.roles);
  const rootRoles = useStoreState((state) => state.rootRoles);
  const setRootRoles = useStoreActions((actions) => actions.setRootRoles);

  const [preveledges, setPreveledges] = useState([
    // {
    //   name: '', checked: false, parent: ''
    // }, {
    // }
  ]);

  function checkIfRoleIsPresent(item) {
    const findItem = rootRoles.find(
      (role) =>
        role.parent === item.parent && role.name === item.name && role.checked
    );

    return findItem;
  }

  const userRoles = useMemo(() => {
    const adminAvailableRolesPrivileges = roles?.roles
      .filter((role) => checkIfRoleIsPresent(role))
      .map((role) => {
        return {
          ...role,
          priviledges: role.priviledges.filter((role) =>
            checkIfRoleIsPresent(role)
          ),
        };
      })
      .map((role) => {
        return {
          ...role,
          priviledges:
            role.priviledges &&
            role.priviledges
              .map((role) => {
                return {
                  ...role,
                  actions:
                    role?.actions &&
                    role.actions.filter((role) => checkIfRoleIsPresent(role)),
                };
              })
              .map((role) => {
                return {
                  ...role,
                  priveledges:
                    role.priveledges &&
                    role.priveledges.map((role) => {
                      return {
                        ...role,
                        actions:
                          role.actions &&
                          role.actions.map((role) => {
                            return {
                              ...role,
                              subActions: role.subActions.filter((role) =>
                                checkIfRoleIsPresent(role)
                              ),
                            };
                          }),
                      };
                    }),
                };
              }),
        };
      });

    // staffSavedPrivilegesstaffRoles

    return adminAvailableRolesPrivileges;
  }, [roles.roles, rootRoles, checkIfRoleIsPresent]);

  const getSavedStaffRolesPrivileges = async () => {
    const response = await fetch(
      `${backendUrl}/api/users/get-staff-roles-priviledges/${userId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    const { data } = res;
    const { staffRoles } = data;
    setPriveledges(
      !isEmpty(staffRoles)
        ? staffRoles
        : !isEmpty(savedDeptRoles)
        ? savedDeptRoles
        : []
    );
    return staffRoles;
  };

  const { staffRoles, isLoading, isError } = useQuery(
    ["GET_STAFF_ROLES_PRIVILEGES"],
    () => getSavedStaffRolesPrivileges(),
    {}
  );

  const isChecked = (item) => {
    // console.log(item)

    const found = preveledges.find((el) => el.name === item.name);
    // console.log('found')

    // console.log(found)

    if (!found) {
      return false;
    }

    return !found.checked;
  };

  // const handleChange = (checked, role) => {
  //   console.log(checked);

  //   // const found = preveledges.find(el => el.name === item.name)
  //   console.log(preveledges);
  //   console.log(role.priviledges);

  //   if (role.priviledges !== undefined) {
  //     role.priviledges.map((priviledge) => {
  //       setPreveledges((preveledges) => [
  //         ...preveledges.filter((el) => el.name !== priviledge.name),
  //         {
  //           name: priviledge.name,
  //           checked: checked,
  //           parent: role.name,
  //         },
  //       ]);

  //       // console.log('Priviledges:')
  //       // console.log(priviledge)
  //       // console.log(priviledge.actions)

  //       if (priviledge.actions !== undefined) {
  //         priviledge.actions.map((action) => {
  //           setPreveledges((preveledges) => [
  //             ...preveledges.filter((el) => el.name !== action.name),
  //             {
  //               name: action.name,
  //               checked: checked,
  //               parent: role.name,
  //             },
  //           ]);
  //         });
  //       }
  //     });
  //   }

  //   if (role.actions !== undefined) {
  //     role.actions.map((action) => {
  //       setPreveledges((preveledges) => [
  //         ...preveledges.filter((el) => el.name !== action.name),
  //         {
  //           name: action.name,
  //           checked: checked,
  //           parent: role.name,
  //         },
  //       ]);
  //     });
  //   }

  //   setPreveledges((preveledges) => [
  //     ...preveledges.filter((el) => el.name !== role.name),
  //     {
  //       name: role.name,
  //       checked: checked,
  //       parent: "",
  //     },
  //   ]);

  //   console.log(preveledges);
  // };

  const handleChange = (checked, role) => {
    let roles = [...priveledges];
    checked = !checked;

    if (role.priviledges !== undefined) {
      role.priviledges.map((priviledge) => {
        roles = [
          ...roles.filter(
            (el) =>
              !Boolean(
                el.name == priviledge.name && el.parent == priviledge.parent
              )
          ),
          {
            name: priviledge.name,
            checked: checked,
            parent: role.name,
          },
        ];

        if (priviledge.actions !== undefined) {
          priviledge.actions.map((action) => {
            roles = [
              ...roles.filter(
                (el) =>
                  !Boolean(
                    el.name === action.name && el.parent == action.parent
                  )
              ),
              {
                name: action.name,
                checked: checked,
                parent: priviledge.name,
              },
            ];
            if (action.subActions !== undefined) {
              action.subActions.map((subAction) => {
                roles = [
                  ...roles.filter(
                    (el) =>
                      !Boolean(
                        el.name === subAction.name &&
                          el.parent == subAction.parent
                      )
                  ),
                  {
                    name: subAction.name,
                    checked: checked,
                    parent: action.name,
                  },
                ];
              });
            }
          });
        }
      });
    }

    if (role.actions !== undefined) {
      role.actions.map((action) => {
        roles = [
          ...roles.filter(
            (el) =>
              !Boolean(el.name === action.name && el.parent == action.parent)
          ),
          {
            name: action.name,
            checked: checked,
            parent: role.name,
          },
        ];

        if (action.subActions !== undefined) {
          action.subActions.map((subAction) => {
            roles = [
              ...roles.filter(
                (el) =>
                  !Boolean(
                    el.name === subAction.name && el.parent == subAction.parent
                  )
              ),
              {
                name: subAction.name,
                checked: checked,
                parent: action.name,
              },
            ];
          });
        }
      });
    }

    if (role.subActions !== undefined) {
      role.subActions.map((subAction) => {
        roles = [
          ...roles.filter(
            (el) =>
              !Boolean(
                el.name === subAction.name && el.parent == subAction.parent
              )
          ),
          {
            name: subAction.name,
            checked: checked,
            parent: role.name,
          },
        ];
      });
    }

    roles = [
      ...roles.filter(
        (el) => !Boolean(el.name == role.name && el.parent == role.parent)
      ),
      {
        name: role.name,
        checked: checked,
        parent: role.parent,
      },
    ];

    setPriveledges(roles);
  };

  // const addSettings = async (payload) => {
  //   let response = await fetch(`${backendUrl}/api/users/company-settings`, {
  //     method: "POST",
  //     // credentials: "include",
  //     body: JSON.stringify(payload),
  //     headers: {
  //       Accept: "Application/json",
  //       "Content-Type": "Application/json",
  //     },
  //   });
  //   if (!response.ok) {
  //     response = await response.json();
  //     throw new Error(response.message);
  //   }
  //   const res = await response.json();
  //   return res;
  // };
  // const addSettingsMutation = useMutation((payload) => addSettings(payload), {
  //   onError: () => {
  //     toast.error(`Unable to perform action`);
  //   },
  // });

  // const formik = useFormik({
  //   initialValues: initialGeneralSettings,
  //   onSubmit: (values) => {
  //     //  Save  to  server
  //     addSettingsMutation.mutate(
  //       { settings: values },
  //       {
  //         onSuccess: ({ message, data }) => {
  //           setGeneralSettings(values);
  //           toast.success("Settings saved");
  //           setShowEditUserPriviledgesModal(false);
  //         },
  //       }
  //     );
  //   },
  // });

  // const setUp = async () => {
  //   // await waitFor(5000);
  //   let response = await fetch(`${backendUrl}/api/users/company/settings`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "Application/json",
  //       "Content-Type": "Application/json",
  //     },
  //     credentials: "include",
  //   });

  //   if (!response.ok) {
  //     response = await response.json();
  //     throw new Error(response.message);
  //   }

  //   const { data } = await response.json();
  //   if (data.settings) {
  //     formik.setValues({ ...initialGeneralSettings, ...data.settings });
  //   }

  //   return data;
  // };

  // const { data, isFetching } = useQuery(
  //   ["GET_GLOBAL_SETTINGS"],
  //   () => setUp(),
  //   {
  //     enabled: true,
  //   }
  // );
  // const getUsersInSystem = async () => {
  //   let response = await fetch(`${backendUrl}/api/users`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "Application/json",
  //       "Content-Type": "Application/json",
  //     },
  //     credentials: "include",
  //   });

  //   if (!response.ok) {
  //     response = await response.json();
  //     throw new Error(response.message);
  //   }

  //   const data = await response.json();
  //   data.allUsersInSystem = [
  //     {
  //       label: "Select User",
  //       value: "",
  //     },
  //     ...data.staff.map((el) => ({
  //       label: el.Name,
  //       value: el.Staff_ID,
  //     })),
  //   ];
  //   console.log(data);
  //   return data;
  // };
  // const {
  //   data: { allUsersInSystem } = { allUsersInSystem: [] },
  //   isFetching: isFetchingUsers,
  // } = useQuery(["GET_USERS_IN_SYSTEM"], () => getUsersInSystem(), {});

  // console.log(data);

  const addSettings = async (payload) => {
    const cookies = new Cookies();
    const token = cookies.get("x-access-token");
    let response = await fetch(
      `${backendUrl}/api/users/save-roles-priviledges`,
      {
        method: "POST",
        // credentials: "include",
        body: JSON.stringify({
          roles: payload.priveledges,
          Staff_ID: userId,
        }),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const addSettingsMutation = useMutation((payload) => addSettings(payload), {
    onError: () => {
      toast.error(`Unable to perform action`);
    },
    onSuccess: () => {},
  });

  const formik = useFormik({
    initialValues: {
      /* priveledges,
      Staff_ID: "", */
    },
    onSubmit: (values) => {
      //  Save  to  server
      addSettingsMutation.mutate(
        { priveledges },
        {
          onSuccess: ({ message, data }) => {
            //  setRootRoles(data.rootRoles);
            toast.success("Roles & Priviledges saved");
            setShowRolesPriviledgesModal(false);
          },
        }
      );
    },
  });

  const setUp = async () => {
    // formik.setFieldValue("userld", '');
  };

  const { data, isFetching } = useQuery(
    ["GET_GLOBAL_SETTINGS"],
    () => setUp(),
    {
      enabled: true,
    }
  );
  const getUsersInSystem = async () => {
    let response = await fetch(`${backendUrl}/api/users`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const data = await response.json();
    data.allUsersInSystem = [
      {
        label: "Select User",
        value: "",
      },
      ...data.staff.map((el) => ({
        label: el.Name,
        value: el.Staff_ID,
      })),
    ];

    return data;
  };
  const {
    data: { allUsersInSystem } = { allUsersInSystem: [] },
    isFetching: isFetchingUsers,
  } = useQuery(["GET_USERS_IN_SYSTEM"], () => getUsersInSystem(), {});

  const handleSelectChange = (selected) => {
    console.log(selected.value);
    formik.setFieldValue("Staff_ID", selected.value);
  };

  const handleSelectedJornalAccount = (account) => {
    formik.setFieldValue("drumAccountID", account?.AccountID);
    formik.setFieldValue("drumAccountDescription", account?.Description);
    setShowJournalPopover(false);
  };

  eventBus.useCustomEventListener("JOURNAL_ACCOUNT_CREATED", (account) => {
    handleSelectedJornalAccount(account);
  });

  const animatedComponents = makeAnimated();
  const users = useFetchUsers();

  return (
    <>
      <Modal
        size="xl"
        show={showEditUserPriviledgesModal}
        onHide={() => setShowEditUserPriviledgesModal(false)}
        enforceFocus={false}
        className={"roles-priviledges"}
      >
        <Modal.Header closeButton>
          <Modal.Title className="h5">
            <GearIcon /> Roles & Priviledge Settings
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            onSubmit={formik.handleSubmit}
            autoComplete="off"
            style={
              isFetching || isFetchingUsers
                ? { opacity: "0.5", pointerEvents: "none" }
                : {}
            }
          >
            <h2 className="mb-3 mt-2 h5">Users</h2>
            <Form.Label>{userName}</Form.Label>
            <Form.Group className={"col-sm-12 col-md-4 d-none"}>
              <Select
                isMulti
                defaultValue={[{ label: userName, value: userId }]}
                components={animatedComponents}
                options={users}
                value={users.find(
                  (el) => el.value === formik.values.requiredSignatoryStaff_ID
                )}
                onChange={(selected) =>
                  formik.setFieldValue(
                    "requiredSignatoryStaff_ID",
                    selected.value
                  )
                }
                isDisabled={true}
              />
            </Form.Group>

            {isAdmin ? (
              <div className="roles my-4 pt-4">
                {userRoles.map((role, index) => (
                  <div key={index} className={"role-item"}>
                    <h6>
                      <Form.Check
                        inline
                        type={"checkbox"}
                        checked={Boolean(
                          priveledges.find(
                            (el) =>
                              el.name === role.name && el.parent == role.parent
                          )?.checked
                        )}
                        onChange={(e) =>
                          handleChange(
                            Boolean(
                              priveledges.find(
                                (el) =>
                                  el.name === role.name &&
                                  el.parent == role.parent
                              )?.checked
                            ),
                            role
                          )
                        }
                      />
                      &nbsp;
                      {role.name}
                    </h6>
                    <div className="priviledges">
                      {role.priviledges.map((priviledge, pIndex) => (
                        <Fragment key={pIndex}>
                          <p>
                            <Form.Check
                              inline
                              type={"checkbox"}
                              checked={Boolean(
                                priveledges.find(
                                  (el) =>
                                    el.name === priviledge.name &&
                                    el.parent == priviledge.parent
                                )?.checked
                              )}
                              onChange={(e) =>
                                handleChange(
                                  Boolean(
                                    priveledges.find(
                                      (el) =>
                                        el.name === priviledge.name &&
                                        el.parent == priviledge.parent
                                    )?.checked
                                  ),
                                  priviledge
                                )
                              }
                            />
                            &nbsp;{priviledge.name}
                          </p>
                          <ul className="actions">
                            {priviledge.actions?.map((action, aIndex) => (
                              <li key={aIndex}>
                                <Form.Check
                                  inline
                                  type={"checkbox"}
                                  checked={Boolean(
                                    priveledges.find(
                                      (el) =>
                                        el.name === action.name &&
                                        el.parent == action.parent
                                    )?.checked
                                  )}
                                  onChange={(e) =>
                                    handleChange(
                                      Boolean(
                                        priveledges.find(
                                          (el) =>
                                            el.name === action.name &&
                                            el.parent == action.parent
                                        )?.checked
                                      ),
                                      action
                                    )
                                  }
                                />
                                &nbsp;{action.name}
                                <ul className="actions">
                                  {action?.subActions?.map(
                                    (subAction, aIndex) => (
                                      <li li key={aIndex}>
                                        <Form.Check
                                          inline
                                          type={"checkbox"}
                                          checked={Boolean(
                                            priveledges.find(
                                              (el) =>
                                                el.name === subAction.name &&
                                                el.parent == subAction.parent
                                            )?.checked
                                          )}
                                          onChange={(e) =>
                                            handleChange(
                                              Boolean(
                                                priveledges.find(
                                                  (el) =>
                                                    el.name ===
                                                      subAction.name &&
                                                    el.parent ==
                                                      subAction.parent
                                                )?.checked
                                              ),
                                              subAction
                                            )
                                          }
                                        />
                                        &nbsp;{subAction.name}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </li>
                            ))}
                          </ul>
                        </Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => formik.submitForm()}
            variant="primary"
            disabled={addSettingsMutation.isLoading}
            className="px-4"
          >
            {addSettingsMutation.isLoading ? "Please wait..." : "Save"}
          </Button>
        </Modal.Footer>
        {/* <Modal.Body>
          <Form
            noValidate
            onSubmit={formik.handleSubmit}
            autoComplete="off"
            style={
              isFetching || isFetchingUsers
                ? { opacity: "0.5", pointerEvents: "none" }
                : {}
            }
          >
            <h2 className="mb-3 mt-2 h5">Users</h2>
            <Form.Group className={"col-sm-12 col-md-4"}>
              <Select
                isMulti
                defaultValue={[{ label: userName, value: userId }]}
                components={animatedComponents}
                options={users}
                value={users.find(
                  (el) => el.value === formik.values.requiredSignatoryStaff_ID
                )}
                onChange={(selected) =>
                  formik.setFieldValue(
                    "requiredSignatoryStaff_ID",
                    selected.value
                  )
                }
                isDisabled={true}
              />
            </Form.Group>

            {isAdmin ? (
              <div className="roles border-top my-4 pt-4">
                {userRoles.map((role, index) => (
                  <div className={"role-item"}>
                    <h6 key={index}>
                      <Form.Check
                        inline
                        type={"checkbox"}
                        checked={isChecked(role)}
                        onChange={(e) => handleChange(isChecked(role), role)}
                      />
                      &nbsp;
                      {role.name}
                    </h6>
                    <div className="priviledges">
                      {role.priviledges.map((priviledge, p) => (
                        <>
                          <p>
                            <Form.Check
                              inline
                              type={"checkbox"}
                              checked={isChecked(priviledge)}
                              onChange={(e) =>
                                handleChange(isChecked(priviledge), priviledge)
                              }
                            />
                            &nbsp;{priviledge.name}
                          </p>
                          <ul className="actions">
                            {priviledge.actions?.map((action, a) => (
                              <li key={a}>
                                <Form.Check
                                  inline
                                  type={"checkbox"}
                                  checked={isChecked(action)}
                                  onChange={(e) =>
                                    handleChange(isChecked(action), action)
                                  }
                                />
                                &nbsp;{action.name}
                              </li>
                            ))}
                          </ul>
                        </>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => formik.submitForm()}
            variant="primary"
            disabled={addSettingsMutation.isLoading}
            className="px-4"
          >
            {addSettingsMutation.isLoading ? "Please wait..." : "Save"}
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
}
